import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, Radio, Tooltip } from "antd";
import { Button } from "@ts-digital/vrc";
import moment from "moment";
import ReplyFile from "./replyFile";
import { FormattedMessage } from "react-intl";

const Item = props => {
  const {
    cn,
    item,    
    myType,
    values,
    onMove,
    onPreview,
    emptyValues,
    moveAll
  } = props;

  function buildFiles(item, idx) {
    let items = [];
    let values = item ? item.value || item : [];
    if (item && !item.value) {
      values = [];
      for (let it in item) {
        values.push(item[it]);
      }
    }
    if (values) {
      values.map(it => {
        items.push(<ReplyFile
          onMove={(documentId, documentName) =>
            onMove(documentId, documentName)
          }
          onPreview={documentId => onPreview(documentId)}
          myType={myType}
          item={it}          
        />);
        return items;
      });
    }
    return items;
  }

  function buildButtonAll(item) {
    let items = [];
    let checkdms = false;
    if (myType === "STUDIO" && item.value && item.value.length > 1) {
      item.value.map(it => {
        if (it.source === "dms") {
          checkdms = true;
        }
        return checkdms;
      });
    }
    if (checkdms) {
      items.push(<div
        style={{ marginTop: 5, display: "flex", justifyContent: "flex-end" }}
      >
        <Button kind="tertiary" onClick={moveAll}>
          <FontAwesomeIcon
            icon={["far", "archive"]}
            style={{ marginRight: 5 }}
          />{" "}
            Aggiungi tutti a documenti
        </Button>
      </div>);
    }
    return items;
  }

  function renderMultichoice(
    item, values, idx
  ) {
    let items = [];
    if (item.type === "radio") {
      item.choices.map(value => {
        items.push(<Radio style={{ display: "block", lineHeight: "22px" }} value={value}>
          {value}
        </Radio>);
        return items;
      });
      return (
        <Radio.Group
          className="askAnswer-item-radio readonly"
          name={"askAnswer-item-field_" + idx}
          value={
            values["askAnswer-item-field_" + idx]
              ? values["askAnswer-item-field_" + idx]
              : item.value
          }
        >
          {items}
        </Radio.Group>
      );
    } 
    item.choices.map(value => {
      items.push({ label: value, value: value });
      return items;
    });
    return (
      <Checkbox.Group
        className="askAnswer-item-checkbox readonly"
        value={values["askAnswer-item-field_" + idx]}
        options={items}
      />
    );
    
  }

  return (
    <div key={"askAnswer-item_" + cn} className={"askAnswer-item"}>
      <div className="askAnswer-item-body">
        <div className="askAnswer-item-question">
          <div className="askAnswer-item-label">
            <div>
              <div>
                {item.label}
                {item.required ? " *" : ""}{" "}
              </div>
            </div>
            {item.hint && item.hint.length > 0 && (
              <span className="askAnswer-item-label-tip-icon">
                <Tooltip title={item.hint} color={"rgb(0, 80, 117)"}>
                  <FontAwesomeIcon icon={["far", "info-circle"]} />
                </Tooltip>
              </span>
            )}
          </div>
          <div className="askAnswer-item-field">
            <div>&nbsp;</div>
            <div className="askAnswer-item-field-container">
              {item.type === "input" ? (
                item.format === "date" ? (
                  emptyValues ? (
                    <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                  ) : item.value && item.value !== "" ? (
                    moment(item.value).format("DD MMM YYYY")
                  ) : (
                    <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                  )
                ) : item.format === "number" ? (
                  emptyValues ? (
                    <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                  ) : item.value && item.value !== "" ? (
                    item.value
                  ) : (
                    <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                  )
                ) : item.format === "currency" ? (
                  emptyValues ? (
                    <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                  ) : item.value && item.value !== "" ? (
                    item.value
                  ) : (
                    <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                  )
                ) : emptyValues ? (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                ) : item.value && item.value !== "" ? (
                  item.value
                ) : (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                )
              ) : item.type === "textarea" ? (
                emptyValues ? (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                ) : item.value && item.value !== "" ? (
                  item.value
                ) : (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                )
              ) : item.type === "file" ? (
                emptyValues ? (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                ) : (
                  <div>
                    <div>{buildFiles(item)}</div>
                    {buildButtonAll(item)}
                  </div>
                )
              ) : item.type === "boolean" ? (
                emptyValues ? (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                ) : item.value && item.value === "true" ? (
                  "Sì"
                ) : (
                  "No"
                )
              ) : item.type === "radio" ? (
                emptyValues ? (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                ) : (
                  renderMultichoice(
                    item, values, cn
                  )
                )
              ) : item.type === "checkbox" ? (
                emptyValues ? (
                  <span className="noReply"><FormattedMessage id="ask.pages.answer.noReply" /></span>
                ) : (
                  renderMultichoice(
                    item, values, cn
                  )
                )
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Item;
